import type { FC } from "react";
import { RequestOutreachStatus, useRequestOutreach } from "../../../hooks/useRequestOutreach";
import type { ShiftRequest } from "../../../utils/models";
import { RequestOutreachPopup } from "./RequestOutreachPopup";

/** Mounted only while open, so a list of cards never builds outreach nobody looks at. */
export const OutreachPopupContainer: FC<{ request: ShiftRequest; onClose: () => void }> = ({ request, onClose }) => {
	const result = useRequestOutreach(request);
	if (result.status === RequestOutreachStatus.Unavailable) return null;
	return <RequestOutreachPopup open onClose={onClose} outreach={result.outreach} actions={result.actions} />;
};
